/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Event_Id_TitleInputs */

const en_event_id_title = /** @type {(inputs: Event_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Event ID`)
};

const fr_event_id_title = /** @type {(inputs: Event_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID de l'evenement`)
};

const de_event_id_title = /** @type {(inputs: Event_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ereignis-ID`)
};

const it_event_id_title = /** @type {(inputs: Event_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID evento`)
};

const ru_event_id_title = /** @type {(inputs: Event_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Идентификатор события`)
};

const es_event_id_title = /** @type {(inputs: Event_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID de evento`)
};

const zh_cn2_event_id_title = /** @type {(inputs: Event_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`事件 ID`)
};

const ja_event_id_title = /** @type {(inputs: Event_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`イベントID`)
};

const hi_event_id_title = /** @type {(inputs: Event_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`इवेंट आईडी`)
};

const pt_pt2_event_id_title = /** @type {(inputs: Event_Id_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ID do evento`)
};

/**
* | output |
* | --- |
* | "Event ID" |
*
* @param {Event_Id_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const event_id_title = /** @type {((inputs?: Event_Id_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Event_Id_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_event_id_title(inputs)
	if (locale === "de") return de_event_id_title(inputs)
	if (locale === "it") return it_event_id_title(inputs)
	if (locale === "ru") return ru_event_id_title(inputs)
	if (locale === "es") return es_event_id_title(inputs)
	if (locale === "zh-CN") return zh_cn2_event_id_title(inputs)
	if (locale === "ja") return ja_event_id_title(inputs)
	if (locale === "hi") return hi_event_id_title(inputs)
	if (locale === "pt-PT") return pt_pt2_event_id_title(inputs)
	return en_event_id_title(inputs)
});